import { render, staticRenderFns } from "./Makes.vue?vue&type=template&id=66396f08&"
import script from "./Makes.vue?vue&type=script&lang=js&"
export * from "./Makes.vue?vue&type=script&lang=js&"
import style0 from "./Makes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
const CoreDivider = () => import(/* webpackChunkName: "CoreDivider" */ '@/components/core/Divider.vue')
const CoreListItem = () => import(/* webpackChunkName: "CoreListItem" */ '@/components/core/ListItem.vue')
installComponents(component, {CoreDivider,CoreListItem})
